class CustomScreenerCriteria extends Tango.Component {
    widgetWillMount(shadow) {
        const els = shadow.querySelectorAll('details');
        const _this = this;
        _this.state = {};

        for (var i = 0, el; el = els[i]; i++) {
            el.addEventListener("toggle", (e) => {
                const d = e.currentTarget;
                const id = d.getAttribute('data-for');
                const content = document.getElementById(id);
                if (d.open) {
                    content.classList.remove('hide');
                } else {
                    content.classList.add('hide');
                }
            });    
        }

        const ta = shadow.querySelector('textarea[name="formula"]');
        ta.addEventListener("focusout", (e) => {
            const text = e.currentTarget.value;
            const cursorPos = e.currentTarget.selectionStart;

            // Split the text into lines
            const lines = text.substring(0, cursorPos).split('\n');

            const row = lines.length - 1;
            const col = lines[row].length;

            _this.state.row = row;
            _this.state.col = col;
        });

        const links = shadow.querySelectorAll('div[data-ctrl="StaticTreeDialog"] a');
        for (var i = 0, el; el = links[i]; i++) {
            el.addEventListener("click", (e) => {
                const d = e.currentTarget;
                const metric = d.getAttribute('data-alias') + ' ';
                insertTextAt(ta, metric, _this.state?.row ?? 0, _this.state?.col ?? 0);
            });
        }

        function insertTextAt(ta, text, row, col) {
            let lines = ta.value.split("\n");
            let line = lines[row];
            line = line.slice(0, col) + text + line.slice(col);
            lines[row] = line;
            ta.value = lines.join("\n");

            let pos = 0;
            for (let i = 0; i < row; i++) {
                pos += lines[i].length + 1;
            }
            pos += col + text.length;

            ta.focus();
            ta.setSelectionRange(pos, pos);
        }
    }

}

Tango.registerComponent(CustomScreenerCriteria);
